import { render } from "./BluePenIcon.vue?vue&type=template&id=e5483a60"
const script = {}

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__